export function calcularIMC(peso: number, altura: number) {
  const imc = peso / (altura / 100) ** 2
  return imc <= 250 ? imc : undefined
}
